module.exports = __webpack_public_path__ + "img/WhatsApp Image 2021-12-12 at 16.57.19.9525978f.jpeg";